import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Beaker } from "lucide-react";

/** Ward-wide banner shown whenever admin has switched on `demo_mode`. */
export default function TrainingBanner() {
  const [on, setOn] = useState(false);

  const load = async () => {
    try { const { data } = await api.get("/admin/settings"); setOn(!!data?.demo_mode); } catch (e) { console.warn("TrainingBanner settings poll failed", e); }
  };
  useEffect(() => {
    load();
    const handler = () => load();
    window.addEventListener("nicu-settings-changed", handler);
    const t = setInterval(load, 60_000);
    return () => { window.removeEventListener("nicu-settings-changed", handler); clearInterval(t); };
  }, []);

  if (!on) return null;
  return (
    <div className="w-full bg-amber-500 text-white" data-testid="training-banner">
      <div className="max-w-[1400px] mx-auto flex items-center justify-center gap-2 px-4 py-1.5 text-xs uppercase tracking-[0.28em] font-semibold">
        <Beaker size={12} /> Training mode — practice ward · not real patient data
      </div>
    </div>
  );
}
